import { ExportPerformanceSpreadsheetReport } from 'domain/usecases';
import { submitHiddenFormInReports } from 'presentation/app/helpers/reports/submit-hidden-form-in-reports';
import { getEnv } from 'shared/get-env';

export const usePerformanceSpreadsheetReport = () => {
  const handlePerformanceSpreadsheetReport = (
    params: ExportPerformanceSpreadsheetReport.Params,
  ) => {
    submitHiddenFormInReports({
      url: `${getEnv('REACT_APP_REPORTS_API_URL')}/professionals/performance-spreadsheet`,
      target: '_blank',
      method: 'POST',
      data: params,
    });
  };

  return { handlePerformanceSpreadsheetReport };
};
